// Request-scoped, module-level store of per-item OpenSearch score debug, keyed by idPmwStockMedia.
// Populated when a stock response arrives; read by the per-tile hover badge.
// Engineer-only tool: active only when the backend isStockScoreDebugEnabled feature flag is on
// AND the current user is a super-user — both resolved via one backend call on first prime.
import type {StockItemScoreDebug, StockScoreDebugAvailabilityResponse, StockScoreDebugPayload} from './stock-panel.types';

let itemsById: Record<string, StockItemScoreDebug> = {};

let isDebugAvailable = false;
let availabilityResolutionStarted = false;

export function primeStockScoreDebugAvailability(): void {
  if (availabilityResolutionStarted) {
    return;
  }
  availabilityResolutionStarted = true;
  void resolveAvailability();
}

async function resolveAvailability(): Promise<void> {
  try {
    const response = (await window.PMW.readLocal('stockmedia/isScoreDebugAvailable')) as StockScoreDebugAvailabilityResponse;
    isDebugAvailable = response.isAvailable;
  } catch (e) {
    console.error('error resolving stock score debug availability', e);
  }
}

export function isStockScoreDebugActive(): boolean {
  return isDebugAvailable;
}

export function ingestStockScoreDebug(payload?: StockScoreDebugPayload | null): void {
  if (!isDebugAvailable || !payload?.items) {
    return;
  }
  itemsById = {...itemsById, ...payload.items};
}

export function getStockItemScoreDebug(idStockMedia: string): StockItemScoreDebug | undefined {
  return itemsById[idStockMedia];
}

export function resetStockScoreDebug(): void {
  itemsById = {};
}
